var isMobile = false;
 if( /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || document.documentElement.clientWidth <= 769 ) {
    isMobile = true;
}
 $(document).ready(function () {
    $('#registroForm').on('submit', function (e) {
      e.preventDefault();

      // Limpiar errores anteriores
      $('input').removeClass('input-error');

      var nombre = $.trim($('input[name="name"]').val());
      var apellido = $.trim($('input[name="lastname"]').val());
      var email = $.trim($('input[name="email"]').val());

      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      var hasError = false;

      // Validar nombre
      if (nombre === '') {
        $('input[name="name"]').addClass('input-error');
        hasError = true;
      }

      // Validar apellido
      if (apellido === '') {
        $('input[name="lastname"]').addClass('input-error');
        hasError = true;
      }

      // Validar email
      if (email === '' || !emailRegex.test(email)) {
        $('input[name="email"]').addClass('input-error');
        hasError = true;
      }

      if (hasError) return;

      var formData = $(this).serialize();
      $('.mgmessage').html('Espere un momento por favor...');      
      $.ajax({
        type: 'POST',
        url: 'https://dev.socialpro.mx/ne_klaviyo/create_update_megaventa.php',
        data: formData,
        success: function (response) {
          window.location.href = "https://www.newera.mx/pages/gracias-por-suscribirte";          
        },
        error: function (error) {
          console.error('Error al enviar los datos', error);
        }
      });
    });
  });
